import React, { useContext, useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import { NewContext } from '../../Context/NewContext';
import { add_bank_regex, get_sms_regex } from '../../Controller/actions';
import { Pagination, SearchAndAddBtn, THead } from '../../Components';
import { RiDeleteBinLine } from 'react-icons/ri';
import { BiEdit } from 'react-icons/bi';
import { Card, CardBody, IconButton, Spinner } from "@material-tailwind/react";
import SmsRegexModel from '../../Components/Modals/SmsRegexModel';
const SmsRegex = ({ title }) => {

    const { formData, permissions, tokenType, setIsLoading, setDeleteUpdateYes, setConfirmationModalShow, setDeleteUpdateItem, confirmationModalShow, setAddEditDeleteTag, handleChange, setFormData, setApiResponse, isLoading, handleOpen, deleteUpdateTag, deleteUpdateYes, search, currentPage, perPage, filterDropdown, sortData, isAscending, setDeleteUpdateTag, totalPage, setCurrentPageData, setCurrentPage, setPerPage, setTotalPage } = useContext(NewContext);
    const [smsData, setSmsData] = useState([]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        let createUpdateSounds;
        setIsLoading(true);
        // setIsModalLoading(true);
        createUpdateSounds = await add_bank_regex(formData)
        if (createUpdateSounds) {
            setApiResponse(createUpdateSounds);
            const { message, status } = createUpdateSounds;
            if (status) {
                toast.success(message);
                setFormData({
                    countryCode: "",
                    language_code: "",
                    credit_transaction: "",
                    debit_transaction: "",
                    promotion: "",
                    otp: "",
                    transaction: "",
                    account_no: "",
                    transaction_amount: "",
                    amount_symbol: "",
                });
                getBankRegexData()
                setIsLoading(false);
                // setIsModalLoading(false);
            } else {
                toast.error(message);
            };
        }
    }

    // const getBankRegexData = async () => {
    //     // setIsModalLoading(true)
    //     try {
    //         const getAsset = await get_sms_regex();
    //         if (getAsset) {
    //             const { status, data } = getAsset;
    //             if (status) {
    //                 setSmsData(data);
    //             }
    //         }
    //     } catch (error) {
    //         console.error('Error fetching bank regex data:', error);
    //     }
    // };

    const getBankRegexData = async (_currentPage = 1, sortName = sortData, sortType = isAscending) => {
        setIsLoading(true)
        try {
            const getAsset = await get_sms_regex(_currentPage, perPage, search, filterDropdown, sortName, sortType);
            if (getAsset) {
                const { status, data, currentPage, perPage, totalPage } = getAsset;
                if (status) {
                    setSmsData(data);
                    setCurrentPageData(data);
                    setCurrentPage(currentPage);
                    setPerPage(perPage);
                    setTotalPage(totalPage || 1);
                }
                else {
                    setCurrentPageData([]);
                }
                setIsLoading(false);
            }
        } catch (error) {
            console.error('Error fetching bank regex data:', error);
        }
    };




    // useEffect(() => {
    //     getBankRegexData();
    // }, []);

    useEffect(() => {
        getBankRegexData(currentPage, sortData, isAscending);
        setDeleteUpdateTag("");
    }, [deleteUpdateTag, deleteUpdateYes, search, currentPage, perPage, filterDropdown, sortData, isAscending]);

    const simpleFields = [
        { name: "Country", sortable: false, field: 'countryCode' },
        { name: "languageCode", sortable: false, field: 'languageCode' },
        { name: "creditTransaction", sortable: false, field: 'creditTransaction' },
        // { name: "DebitTransaction", sortable: false, field: 'debitTransaction' },
        // { name: "Promotion", sortable: false, field: 'promotion' },
        // { name: "Otp", sortable: false, field: 'otp' },
        // { name: "Transaction", sortable: false, field: 'transaction' },
        // { name: "Account No", sortable: false, field: 'accountNo' },
        // { name: "Transaction Amount", sortable: false, field: 'transactionAmount' },
        // { name: "Amount Symbol", sortable: false, field: 'amountSymbol' },
    ];
    const totalFields = simpleFields.length + 2;
    const [pagePermissions, setPagePermissions] = useState({
        CU: true,
        R: true,
        D: true
    });
    useEffect(() => {
        if (tokenType === 'ldap') {
            const update = permissions?.subPermissions?.find((route) => route.name === 'SMS_Regex')
            setPagePermissions({
                ...pagePermissions, CU: update?.CU, R: update?.R, D: update?.D
            })
        }
    }, [tokenType, permissions])

    useEffect(() => {
        document.title = title;
    }, [title])


    useEffect(() => {
        setFormData({ countryCode: '' })
    }, [])

    return (
        <div>
            <SearchAndAddBtn title={`SMS Regex`} addBtn={false} isSearch={true} countryFilter={false} perPageCount={true} />
            <div className='grid grid-cols-12 '>
                <div class="flex items-center p-10 col-span-4 justify-center">
                    <div class="mx-auto w-full max-w-[550px] ">
                        <form onSubmit={handleSubmit}>

                            <div class="mb-5">
                                <label
                                    htmlFor="countryCode"
                                    class="mb-3 block text-base font-medium text-[#07074D]"
                                >
                                    Country
                                </label>
                                <input
                                    type="text"
                                    name="countryCode"
                                    onChange={handleChange}
                                    value={formData?.countryCode || ''}
                                    required
                                    placeholder="Country"
                                    class="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#0047ff] focus:shadow-md"
                                />
                            </div>

                            <div class="mb-5">
                                <label
                                    htmlFor="language_code"
                                    class="mb-3 block text-base font-medium text-[#07074D]" >
                                    Language Code
                                </label>
                                <input
                                    type="text"
                                    name="language_code"
                                    onChange={handleChange}
                                    value={formData?.language_code || ''}
                                    required
                                    placeholder="Language Code"
                                    class="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#0047ff] focus:shadow-md"
                                />
                            </div>

                            <div class="mb-5">
                                <label
                                    htmlFor="credit_transaction"
                                    class="mb-3 block text-base font-medium text-[#07074D]"
                                >
                                    Credit Transaction Regex
                                </label>
                                <input
                                    type="text"
                                    name="credit_transaction"
                                    onChange={handleChange}
                                    value={formData?.credit_transaction || ''}
                                    required
                                    placeholder="Enter your Credit Transaction Regex"
                                    class="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#0047ff] focus:shadow-md"
                                />
                            </div>

                            <div class="mb-5">
                                <label
                                    htmlFor="debit_transaction"
                                    class="mb-3 block text-base font-medium text-[#07074D]"
                                >
                                    Debit Transaction Regex
                                </label>
                                <input
                                    type="text"
                                    name="debit_transaction"
                                    onChange={handleChange}
                                    value={formData?.debit_transaction || ''}
                                    required
                                    placeholder="Enter your Debit Transaction Regex"
                                    class="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#0047ff] focus:shadow-md"
                                />
                            </div>

                            <div class="mb-5">
                                <label
                                    htmlFor="promotion"
                                    class="mb-3 block text-base font-medium text-[#07074D]"
                                >
                                    Promotion Regex
                                </label>
                                <input
                                    type="text"
                                    name="promotion"
                                    onChange={handleChange}
                                    value={formData?.promotion || ''}
                                    required
                                    placeholder="Enter your Promotion Regex"
                                    class="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#0047ff] focus:shadow-md"
                                />
                            </div>

                            <div class="mb-5">
                                <label
                                    htmlFor="otp"
                                    class="mb-3 block text-base font-medium text-[#07074D]"
                                >
                                    OTP Regex
                                </label>
                                <input
                                    type="text"
                                    name="otp"
                                    onChange={handleChange}
                                    value={formData?.otp || ''}
                                    required
                                    placeholder="Enter your OTP Regex"
                                    class="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#0047ff] focus:shadow-md"
                                />
                            </div>

                            <div class="mb-5">
                                <label
                                    htmlFor="transaction"
                                    class="mb-3 block text-base font-medium text-[#07074D]"
                                >
                                    Transaction Regex
                                </label>
                                <input
                                    type="text"
                                    name="transaction"
                                    onChange={handleChange}
                                    value={formData?.transaction || ''}
                                    required
                                    placeholder="Enter your Transaction Regex"
                                    class="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#0047ff] focus:shadow-md"
                                />
                            </div>

                            <div class="mb-5">
                                <label
                                    htmlFor="account_no"
                                    class="mb-3 block text-base font-medium text-[#07074D]"
                                >
                                    Account No Regex
                                </label>
                                <input
                                    type="text"
                                    name="account_no"
                                    onChange={handleChange}
                                    value={formData?.account_no || ''}
                                    required
                                    placeholder="Enter yourAccount No Regex"
                                    class="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#0047ff] focus:shadow-md"
                                />
                            </div>

                            <div class="mb-5">
                                <label
                                    htmlFor="transaction_amount"
                                    class="mb-3 block text-base font-medium text-[#07074D]"
                                >
                                    Amount Regex
                                </label>
                                <input
                                    type="text"
                                    name="transaction_amount"
                                    onChange={handleChange}
                                    value={formData?.transaction_amount || ''}
                                    required
                                    placeholder="Enter yourAmount Regex"
                                    class="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#0047ff] focus:shadow-md"
                                />
                            </div>

                            <div class="mb-5">
                                <label
                                    htmlFor="amount_symbol"
                                    class="mb-3 block text-base font-medium text-[#07074D]"
                                >
                                    Amount Symbol Regex
                                </label>
                                <input
                                    type="text"
                                    name="amount_symbol"
                                    onChange={handleChange}
                                    value={formData?.amount_symbol || ''}
                                    required
                                    placeholder="Enter yourAmount Symbol Regex"
                                    class="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#0047ff] focus:shadow-md"
                                />
                            </div>

                            <div>
                                <button
                                    class="hover:shadow-form rounded-md bg-[#0047ff] py-3 px-8 text-base font-semibold text-white outline-none">
                                    Submit
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
                <div className='col-span-8 h-[840px] rounded-md overflow-y-scroll bg-white'>
                    <Card className="overflow-hidden w-full rounded-md shadow-none">
                        <CardBody className="overflow-x-auto w-100 py-8 px-[10px] card-body-scrollbar">
                            <table className="w-full min-w-max table-auto text-left">
                                <THead simpleFields={simpleFields} isSelectAll={false} />
                                <tbody>
                                    {
                                        isLoading ?
                                            <tr>
                                                <td colSpan={totalFields} className='py-12'>
                                                    <div className="flex justify-center items-center">
                                                        <Spinner />
                                                    </div>
                                                </td>
                                            </tr>
                                            : smsData?.length === 0 ?
                                                <tr>
                                                    <td colSpan={totalFields} className='py-12 bg-gray-200'>
                                                        <div className="flex justify-center items-center">
                                                            No Data Found
                                                        </div>
                                                    </td>
                                                </tr>
                                                : smsData?.map((_ele, i) => {
                                                    const isLast = i === smsData?.length - 1;
                                                    const classes = `text-[#1E1627] ${isLast ? "p-4" : "p-[14.5px]"}`;

                                                    return (
                                                        <tr key={i} className='border-b border-blue-gray-50 '>

                                                            <td className={classes}>
                                                                <div className="flex items-center ml-4">
                                                                    <span className={'font-normal text-[17px] w-44 truncate'}>{_ele?.countryCode || `None`}</span>
                                                                </div>
                                                            </td>
                                                            <td className={classes}>
                                                                <div className="flex items-center ">
                                                                    <span className={'font-normal text-[17px] w-44 truncate'}>{_ele?.language_code || `None`}</span>
                                                                </div>
                                                            </td>
                                                            <td className={classes}>
                                                                <div className="flex items-center ">
                                                                    <span className={'font-normal text-[17px] w-96 truncate'}>{_ele?.credit_transaction || `None`}</span>
                                                                </div>
                                                            </td>
                                                            {/* <td className={classes}>
                                                                <div className="flex items-center ">
                                                                    <span className={'font-normal text-[17px] w-96 truncate'}>{_ele?.debit_transaction || `None`}</span>
                                                                </div>
                                                            </td>
                                                            <td className={classes}>
                                                                <div className="flex items-center">
                                                                    <span className={'font-normal text-[17px] w-96 truncate'}>{_ele?.promotion || `None`}</span>
                                                                </div>
                                                            </td>
                                                            <td className={classes}>
                                                                <div className="flex items-center">
                                                                    <span className={'font-normal text-[17px] w-96 truncate'}>{_ele?.otp || `None`}</span>
                                                                </div>
                                                            </td>
                                                            <td className={classes}>
                                                                <div className="flex items-center">
                                                                    <span className={'font-normal text-[17px] w-96 truncate'}>{_ele?.transaction || `None`}</span>
                                                                </div>
                                                            </td>
                                                            <td className={classes}>
                                                                <div className="flex items-center">
                                                                    <span className={'font-normal text-[17px] w-96 truncate'}>{_ele?.account_no || `None`}</span>
                                                                </div>
                                                            </td>
                                                            <td className={classes}>
                                                                <div className="flex items-center">
                                                                    <span className={'font-normal text-[17px] w-96 truncate'}>{_ele?.transaction_amount || `None`}</span>
                                                                </div>
                                                            </td>
                                                            <td className={classes}>
                                                                <div className="flex items-center">
                                                                    <span className={'font-normal text-[17px] w-96 truncate'}>{_ele?.amount_symbol || `None`}</span>
                                                                </div>
                                                            </td> */}

                                                            <td className={classes}>
                                                                <div className="flex items-center gap-2">
                                                                    <IconButton
                                                                        onClick={() => { setDeleteUpdateYes("update-sms-regex"); setAddEditDeleteTag(`update`); setFormData(_ele); handleOpen() }}
                                                                        className='bg-[#EAEDF3] text-[#0047FF] text-[21px] shadow-none hover:shadow-none'
                                                                    >
                                                                        <BiEdit />
                                                                    </IconButton>
                                                                    <IconButton
                                                                        onClick={() => { setDeleteUpdateYes("delete-sms-regex"); setDeleteUpdateItem({ id: _ele._id }); setConfirmationModalShow(!confirmationModalShow) }}
                                                                        className='bg-[#EAEDF3] text-[#F62929] text-[21px] shadow-none hover:shadow-none'
                                                                    >
                                                                        <RiDeleteBinLine />
                                                                    </IconButton>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                    }
                                </tbody>
                            </table>
                        </CardBody>
                    </Card>
                    <SmsRegexModel getSmsData={getBankRegexData} />
                </div>

            </div>
            {
                totalPage > 1 &&
                <Pagination currentPage={currentPage} totalPage={totalPage} getData={getBankRegexData} />
            }
        </div>
    )
}
SmsRegex.defaultProps = {
    title: "Message | SmsRegex"
};

export default SmsRegex
